// extracted by mini-css-extract-plugin
module.exports = {"page-loader":"_7BdEF","message":"JiYLN"};